module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-matters-02-fce9d66f785ba0d105981f614011a438.png";